import axios from 'axios';

const getPrevisaoEntrega = idProduto => axios.get(`requisicoes/produtos/${idProduto}/previsao-entrega`, {});

export default {
  getPrevisaoEntrega,
};
